// extracted by mini-css-extract-plugin
export var descriptionBody = "styles-module__descriptionBody___eqyzV";
export var descriptionContainer = "styles-module__descriptionContainer___Lbmk_";
export var descriptionTitle = "styles-module__descriptionTitle___UCOoW";
export var image = "styles-module__image___A49g3";
export var imageContainer = "styles-module__imageContainer___cv_6Y";
export var leftSlide = "styles-module__leftSlide___5s49Y";
export var middleSlide = "styles-module__middleSlide___KORWS";
export var rightSlide = "styles-module__rightSlide___jW4aX";
export var slideContainer = "styles-module__slideContainer___TFMRl";
export var slideInnerContainer = "styles-module__slideInnerContainer___OsxFg";